// Common text styles that can be reused across components
const textStyles = {
  fontPrimary: {
    fontFamily: 'Lato',
    color: 'var(--color-text-primary)',
  },
  fontSecondary: {
    fontFamily: 'Lato',
    color: 'var(--color-text-secondary)',
  },
  heading: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 8,
  },
  paragraph: {
    fontSize: 14,
  },
  boldText: {
    fontWeight: 'bold',
  },
}

// Common layout styles
const layoutStyles = {
  flexRow: {
    display: 'flex',
    alignItems: 'center',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  centered: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: 'var(--color-white)',
    borderRadius: 10,
    padding: 20,
  },
}

// Common UI element styles
const uiElementStyles = {
  circleIcon: {
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  roundedBox: {
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

export const styles = theme => ({
  paragraph: {
    ...textStyles.fontSecondary,
    ...textStyles.paragraph,
  },
  container: {
    margin: '30px 30px 30px 0px',
    minWidth: 800,
  },
  formControl: {
    marginBottom: 16,
  },
  subHeading: {
    ...textStyles.fontPrimary,
    ...textStyles.boldText,
    fontSize: 16,
    marginTop: 24,
    marginBottom: 16,
  },
  inputContainer: {
    marginTop: 30,
    marginBottom: 30,
  },
  buttonContainer: {
    ...layoutStyles.flexRow,
    justifyContent: 'flex-end',
    marginBottom: 30,
    padding: '30px 30px 0 30px',
    borderTop: '1px solid var(--color-issabeline-grey)',
  },
  buttonGroup: {
    ...layoutStyles.flexRow,
    justifyContent: 'flex-end',
  },
  formLayout: {
    ...layoutStyles.flexRow,
    alignItems: 'stretch',
    width: '100%',
    marginTop: 30,
    ...layoutStyles.card,
    padding: '0',
  },
  stepperContainer: {
    ...layoutStyles.flexColumn,
    width: '234px',
    borderRight: '1px solid var(--color-issabeline-grey)',
    padding: '30px 10px 10px 10px',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  stepItem: {
    ...layoutStyles.flexRow,
    alignItems: 'center',
    marginBottom: 40,
    position: 'relative',
  },
  stepNumber: {
    ...uiElementStyles.circleIcon,
    width: 40,
    height: 40,
    fontWeight: 500,
    fontSize: 16,
    marginRight: 12,
  },
  stepLabel: {
    ...textStyles.fontPrimary,
    fontSize: 14,
    fontWeight: 600,
    marginTop: 0,
  },
  stepConnector: {
    position: 'absolute',
    left: 20,
    top: 40,
    width: 1,
    height: 51,
    backgroundImage: 'linear-gradient(to bottom, var(--color-border-primary) 33%, rgba(255, 255, 255, 0) 0%)',
    backgroundPosition: 'center',
    backgroundSize: '1px 17px', // Adjust this value to control dash spacing (format: width height)
    backgroundRepeat: 'repeat-y',
  },
  formContent: {
    flex: 1,
    minHeight: 696,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 1042,
    justifyContent: 'space-between',
  },
  infoSection: {
    ...layoutStyles.flexColumn,
    width: 214,
    // Same ice-blue as breadcrumbs on CareBrain; remaps to pine tint on QCS.
    backgroundColor: 'var(--color-breadcrumb-blue)',
    borderRadius: 15,
    padding: 16,
    alignItems: 'flex-start',
  },
  infoIcon: {
    ...uiElementStyles.roundedBox,
    width: 35,
    height: 35,
    backgroundColor: 'var(--color-white)',
    color: 'var(--color-text-blue)',
    fontSize: 18,
  },
  infoTitle: {
    ...textStyles.heading,
    fontSize: 14,
    color: 'var(--color-text-dark)',
    margin: '15px 0px 10px 0px',
  },
  infoText: {
    ...textStyles.paragraph,
    fontSize: 12,
    fontWeight: 400,
    color: 'rgb(130, 130, 130)',
    margin: 0,
  },
  unsavedModalPaper: {
    padding: '24px !important',
    width: '600px !important',
    overflow: 'hidden',
  },
})
